import { Helmet, HelmetProvider } from "react-helmet-async";
import { HashLink } from "react-router-hash-link";

import "../../assets/css/container/services/gentlemen.css";
import GentlemenBanner from "../../assets/img/gentlemen-banner.png";

const Gentlemen = () => {
  const gentServices = [
    { name: "Regular Haircut", price: 30 },
    { name: "Haircut + Beard", price: 40 },
    { name: "Fades", price: 35 },
    { name: "Shape Up", price: 25 },
    { name: "Beard Trim", price: 20 },
    { name: "Kids Cuts (under 9 years and below)", price: 25 },
    { name: "Hairline Trim", price: 15 },
    { name: "Taper", price: 35 },
    { name: "Ladies Cut", price: 35 },
  ];

  return (
    <HelmetProvider>
      <section className="gentlemen-page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{"Kadi's Hair Gallery | Gentlemen's Services"}</title>
        </Helmet>

        {/* --- Banner Section --- */}
        <div className="gentlemen-banner">
          <img src={GentlemenBanner} alt="Gentlemen Banner" className="banner-img" />
          <div className="banner-overlay">
            <h2>Gentlemen’s Grooming, Redefined</h2>
            <p>Classic Cuts. Modern Style.</p>
          </div>
        </div>

        {/* --- Navigation Link to Ladies Page --- */}
        <p className="gent-heading">
          <HashLink to="/ladies#" className="ladies-gent-heading">
            Go to the Ladies Services
          </HashLink>
        </p>

        {/* --- Intro Section --- */}
        <div className="intro-section">
          <h1>Men’s Services</h1>
          <p>
            Experience precision cuts, clean fades, and professional beard
            grooming tailored to your unique style. Our skilled barbers ensure
            every detail is sharp — every time.
          </p>
        </div>

        {/* --- Service List --- */}
        <div className="gentlemen-list">
          {gentServices.map((gentService, index) => (
            <div key={index} className="gentlemen-item">
              <span className="service-name">{gentService.name}</span>
              <span className="service-price">${gentService.price}</span>
            </div>
          ))}
        </div>

        {/* --- Contact Section --- */}
        <div className="contact-bar">
          <p>Ready for your next cut?</p>
          <a href="tel:7033341368" className="call-btn">
            Call (703) 334-1368
          </a>
        </div>
      </section>
    </HelmetProvider>
  );
};

export default Gentlemen;
